import { render, staticRenderFns } from "./client-journal-filter-dialog.vue?vue&type=template&id=4be6ccb4&scoped=true"
import script from "./client-journal-filter-dialog.vue?vue&type=script&lang=js"
export * from "./client-journal-filter-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6ccb4",
  null
  
)

export default component.exports